<!-- <div style="background: #E5E5E5; padding: 20px;">
    <h1>Tab component</h1> -->
<div class="tab-group">
            <div class="tab-group__header">
                <div *ngFor="let tabItem of tabItems$ | async" 
                    [title]="tabItem.label" 
                    (click)="selectTab(tabItem)" 
                    [ngClass]="{'tab-button-active': tabItem == activeTab}" 
                    class="tab-button"
                >
                    {{tabItem.label}}
                </div>
                <!-- <span class="tab-button">ხელიმისაწვდომობა</span>
                <span class="tab-button">შავი სია</span> -->
                <div class="default-fill"></div>
            </div>
        <div class="tab-item-container">
            <ng-container *ngTemplateOutlet="activeTab?.tabContent">

            </ng-container>
        </div>
</div>
